// Generated by purs version 0.14.1
"use strict";
var $foreign = require("./foreign.js");
module.exports = {
    grammar: $foreign.grammar
};
